import React from 'react'
import { createRoot } from 'react-dom/client'
import { createInertiaApp } from '@inertiajs/react'
import 'iconify-icon'
import PrototypeLayout from './Pages/PrototypeLayout'

function normalizeLandingHashAliases() {
  if (window.location.hash !== '#storyboard') return
  if (!['/', '/prototype-landing'].includes(window.location.pathname)) return

  window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}#shot-list`)
}

normalizeLandingHashAliases()

createInertiaApp({
  // Auto-resolve page components from the filesystem.
  // esbuild statically analyzes this template-literal dynamic import and
  // bundles every `./Pages/**/*.jsx` file as a code-split chunk, so new page
  // components are picked up with no entrypoint edit.
  resolve: async (name) => {
    const mod = await import(`./Pages/${name}.jsx`)
    // Apply persistent layout to all prototype pages unless they opt out
    mod.default.layout = mod.default.layout ?? ((page) => <PrototypeLayout>{page}</PrototypeLayout>)
    return mod
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />)
  },
})
